import DealerRolesInfoTab from "../Tabs/dealerRoles/InfoTab";
import DealerRolesDevicesTab from "../Tabs/dealerRoles/DevicesTab";
import DealerRolesBillsTab from "../Tabs/dealerRoles/BillsTab";
import DealerRolesProductSettingsTab from "../Tabs/dealerRoles/ProductSettingsTab";
import DealerRolesUsersTab from "../Tabs/dealerRoles/UsersTab";
import DealerRolesSubFirmsTab from "../Tabs/dealerRoles/SubFirmsTab";
import DealerRolesStatsTab from "../Tabs/dealerRoles/StatsTab";
import DealerRolesReportTab from "../Tabs/dealerRoles/ReportTab";

export default function DealerRolesFirmTabContent({
  selectedTab,
  firm,
  onFirmUpdate,
  onNavigateToFirm,
  isOwnDealerFirm,
  onOpenReportSettings,
}) {
  return (
    <div className="flex-1 min-h-0 overflow-hidden">
      {selectedTab === "info" && (
        <div className="h-full bg-gray-50/40">
          <DealerRolesInfoTab
            firm={firm}
            onFirmUpdate={onFirmUpdate}
            onSelectedFirm={onNavigateToFirm}
            onOpenReportSettings={onOpenReportSettings}
          />
        </div>
      )}
      {selectedTab === "devices" && (
        <div className="h-full">
          <DealerRolesDevicesTab firm={firm} />
        </div>
      )}
      {selectedTab === "productSettings" && (
        <div className="h-full">
          <DealerRolesProductSettingsTab firm={firm} isOwnDealerFirm={isOwnDealerFirm} />
        </div>
      )}
      {selectedTab === "bills" && (
        <div className="h-full">
          <DealerRolesBillsTab firm={firm} />
        </div>
      )}
      {selectedTab === "subfirms" && (
        <div className="h-full">
          {/* Bayide alt bayiler + müşteriler tek sekmede (#376) */}
          <DealerRolesSubFirmsTab onSelectedFirm={onNavigateToFirm} firm={firm} />
        </div>
      )}
      {selectedTab === "users" && (
        <div className="h-full">
          {/* Kullanıcılar + kullanıcı şablonları tek sekmede (#298) */}
          <DealerRolesUsersTab firm={firm} />
        </div>
      )}
      {selectedTab === "stats" && (
        <div className="h-full">
          <DealerRolesStatsTab firm={firm} />
        </div>
      )}
      {selectedTab === "reports" && (
        <div className="h-full">
          <DealerRolesReportTab firm={firm} />
        </div>
      )}
    </div>
  );
}
